export default __webpack_public_path__ + "static/media/sent.0c641f37.png";